import * as React from "react";

import { SpecialCTA } from "@/components/cta-special";

interface ConsultationCTAProps {
  children: React.ReactNode;
  ctaLink: string;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
}

export function ConsultationCTA({ ctaLink, children, className, size }: ConsultationCTAProps) {
  const handleConsultationClick = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_PUBLIC_API_ENDPOINT}${ctaLink}`,
        {
          method: "POST",
          credentials: "include",
        },
      );

      if (response.ok) {
        const { url } = await response.json();
        window.open(url, "_blank");
      } else {
        console.error("Failed to get consultation link");
      }
    } catch (error) {
      console.error("Error getting consultation link:", error);
    }
  };

  return <SpecialCTA onClick={handleConsultationClick} className={className} size={size}>{children}</SpecialCTA>;
}
